/* mc-cart-help.js (bundle-ux 2026-10-16, speed fix). One deferred file for the cart and help pieces that used to sit
   inline on every page. Loaded by snippets/mc-seniors-discount.liquid (theme layout and the cart drawer section) and
   snippets/mc-site-nav.liquid; the first copy to run sets everything up and later copies stop at the guard.
   1. Seniors Card popup: built the first time a [data-scd-open] is tapped (no markup in the page until then), card
      number saved as the "Seniors Card Number" cart attribute and SENIORS10-SO4G applied with cart/update.js. The code
      covers the three CrafterMotion bases and the three Sleep Kits and combines with nothing, so the bigger saving is
      kept. The base product page banner (rendered by the snippet on base pages) moves up beside the buy buttons.
   2. A popup opened over the cart drawer pauses the drawer's focus trap, so taps in it reach it and closing it leaves
      the drawer open.
   3. "Prefer an emailed invoice? Send us your order": opens the page's own quote form (bundles and kit pages), or the
      copy kept in a <template> on /cart, or goes to /cart#mc-send-order, which opens it there with the cart typed in.
   4. Delivery: the drawer's top line and the "Delivery" line in the totals follow the checker's saved postcode
      (localStorage mc_postcode, window.MC_ZONES from assets/mc-delivery-zones.js, loaded only when needed).
   5. Cart drawer: chat launcher hidden while open, Back closes it (one history entry while open).
   6. Menu cart bag (mc-site-nav): count kept current, and it steps aside where the header has its own cart link.
   7. Shared styles for the drawer rows, injected once (the drawer is hidden until opened; /cart has its own copy inline). */
(function () {
  'use strict';
  if (window.__mcCartHelpLoaded) return;
  window.__mcCartHelpLoaded = true;

  var me = document.currentScript;
  var ZONES_URL = (me && me.getAttribute('data-zones')) || '';
  var CODE = 'SENIORS10-SO4G';
  var HANDLES = ['craftermotion-1-0', 'craftermotion-2-0-adjustable-bed-base', 'craftermotion-3-0', 'craftermotion-1-0-sleep-kit', 'craftermotion-2-0-sleep-kit', 'craftermotion-3-0-sleep-kit'];
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- 7. shared styles ---------- */
  var CSS = [
    '.scd-row{display:flex;flex-direction:column;align-items:flex-start;gap:8px;padding:12px 0 2px}',
    '.scd-row-text{margin:0;font-size:15px;line-height:1.45;color:#252525}',
    '.scd-row-sub{margin:-4px 0 0;font-size:14px;line-height:1.4;color:#4f4f48}',
    '.scd-row-btn{min-height:44px;padding:10px 16px;border:1px solid #252525;border-radius:8px;background:transparent;color:#252525;font:inherit;font-size:15px;font-weight:600;cursor:pointer}',
    '.scd-row-btn:hover{background:#F0EFE0}.scd-row-btn:focus-visible{outline:2px solid #252525;outline-offset:2px}',
    '.scd-row--cart{padding:4px 0 8px}',
    '.scd-row--on{flex-direction:row;align-items:center;justify-content:space-between;gap:12px}',
    '.scd-row--on .scd-row-text{display:flex;align-items:center;gap:6px;color:#1a7a3c}',
    '.scd-row-link{min-height:44px;padding:0 4px;border:0;background:none;color:#252525;font:inherit;font-size:15px;text-decoration:underline;text-underline-offset:3px;cursor:pointer;white-space:nowrap}',
    '.mcd-line{display:flex;flex-direction:column;gap:2px}.mcd-amt{color:#1a7a3c;white-space:nowrap}.mcd-note{margin:0;line-height:1.4}',
    '.mcd-deliv{text-align:right}.mcd-deliv-link{color:inherit;text-decoration:underline;text-underline-offset:3px}',
    '.mc-help{display:flex;flex-direction:column;gap:0}',
    '.mc-help a{display:flex;align-items:center;min-height:44px;color:#252525;font-size:15px;line-height:22px;text-decoration:none}',
    '.mc-help a b{font-weight:600;text-decoration:underline;text-underline-offset:3px}.mc-help a:hover b,.mc-help a:focus-visible b{text-decoration-thickness:2px}',
    '.mc-li-note{margin:0}.mc-li-note--bo{color:#8a4b00}',
    '#cart-drawer .line-item .line-item__info>p.text-sm.mc-li-note{order:4;line-height:1.35}',
    '#cart-drawer .line-item .line-item__info>ul.list-disc{order:2;margin:0}',
    '#cart-drawer .mc-cd-delivery svg{flex-shrink:0}',
    '#cart-drawer .mc-help a{min-height:40px;font-size:14px;line-height:20px}',
    '#cart-drawer .scd-row{padding:0 0 4px}#cart-drawer .cart-drawer__code{padding-top:2px}',
    '@media screen and (max-width:699px){.scd-row-text,.scd-row-btn,.mc-help a{font-size:16px}#cart-drawer .mc-help a{min-height:44px;font-size:15px;line-height:22px}}',
    'html.mc-cart-open shopify-chat,html.mc-cart-open #shopify-chat,html.mc-cart-open #ShopifyChat{display:none!important}',
    '.scd-overlay{position:fixed;inset:0;background:rgba(20,20,20,.55);z-index:2147483001;display:flex;align-items:center;justify-content:center;padding:20px}',
    '.scd-overlay[hidden]{display:none}',
    '.scd-modal{position:relative;background:#F0EFE0;color:#252525;border:2px solid #252525;border-radius:12px;max-width:430px;width:100%;max-height:calc(100vh - 40px);overflow-y:auto;padding:28px 26px 22px;font-size:16px;line-height:1.5}',
    '.scd-x{position:absolute;top:6px;right:8px;width:44px;height:44px;background:none;border:none;font-size:28px;line-height:1;color:#252525;cursor:pointer;padding:0}',
    '.scd-title{margin:0 0 10px;padding-right:36px;font-size:22px;line-height:1.2;color:#252525}.scd-copy{margin:0 0 16px}',
    '.scd-lbl{display:block;font-size:15px;font-weight:600;margin-bottom:6px}',
    '.scd-in{display:block;width:100%;border:1.5px solid #252525;border-radius:8px;background:#fff;color:#252525;padding:12px 14px;font-size:16px;margin-bottom:10px}',
    '.scd-err{color:#b3261e;font-size:15px;margin:0 0 10px}',
    '.scd-btn{display:block;width:100%;min-height:48px;background:#252525;color:#F0EFE0;border:none;border-radius:8px;padding:14px 16px;font-size:16px;font-weight:600;cursor:pointer}',
    '.scd-btn[disabled]{opacity:.6;cursor:wait}',
    '.scd-done{background:#fff;border:1.5px solid #1a7a3c;border-radius:8px;color:#1a7a3c;padding:12px 14px;font-size:16px;margin-top:4px}',
    '.scd-fine{font-size:14px;color:#4f4f48;margin:14px 0 0}'
  ].join('');
  (function addStyles() {
    var s = document.createElement('style');
    s.setAttribute('data-mc-cart-help', '');
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  })();

  /* ---------- 2. drawer focus trap pause ---------- */
  var paused = {};
  var trap = null;
  function drawerEl() { return document.getElementById('cart-drawer'); }
  function drawerTrap() {
    var d = drawerEl();
    if (!d || !d.hasAttribute('open')) return null;
    try { return d.focusTrap || null; } catch (e) { return null; }
  }
  window.mcCartHelp = {
    pauseDrawer: function (who) {
      var t = drawerTrap();
      if (!t) return;
      try { t.pause(); trap = t; paused[who] = true; } catch (e) {}
    },
    resumeDrawer: function (who) {
      if (!paused[who]) return;
      delete paused[who];
      if (Object.keys(paused).length || !trap) return;
      var t = trap;
      trap = null;
      try { t.unpause(); } catch (e) {}
    }
  };

  /* ---------- 1. Seniors Card popup ---------- */
  var overlay = null, form, input, err, btn, done, closeTimer = null;
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function buildModal() {
    if (overlay) return;
    var wrap = document.createElement('div');
    wrap.innerHTML =
      '<div class="scd-overlay" id="scd-overlay" hidden>' +
        '<div class="scd-modal" role="dialog" aria-modal="true" aria-labelledby="scd-title">' +
          '<button type="button" class="scd-x" id="scd-x" aria-label="Close">&#215;</button>' +
          '<h3 class="scd-title" id="scd-title">Seniors Card discount</h3>' +
          '<p class="scd-copy">Enter your Seniors Card number and 10 percent comes off the adjustable base or Sleep Kit in your cart. It takes the place of the welcome discount and the spend reward, and we keep whichever saves you more. The number is saved with your order so our team can check your card.</p>' +
          '<form class="scd-form" id="scd-form" novalidate>' +
            '<label class="scd-lbl" for="scd-input">Seniors Card number</label>' +
            '<input class="scd-in" id="scd-input" type="text" autocomplete="off" maxlength="18" spellcheck="false">' +
            '<p class="scd-err" id="scd-err" hidden>Please enter a valid card number (6 to 14 letters and numbers).</p>' +
            '<button type="submit" class="scd-btn" id="scd-btn">Apply discount</button>' +
          '</form>' +
          '<div class="scd-done" id="scd-done" hidden></div>' +
          '<p class="scd-fine">For Australian Seniors Card holders, once per customer, on CrafterMotion adjustable bases and Sleep Kits.</p>' +
        '</div>' +
      '</div>';
    overlay = wrap.firstChild;
    document.body.appendChild(overlay);
    form = overlay.querySelector('#scd-form');
    input = overlay.querySelector('#scd-input');
    err = overlay.querySelector('#scd-err');
    btn = overlay.querySelector('#scd-btn');
    done = overlay.querySelector('#scd-done');
    overlay.querySelector('#scd-x').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeModal(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) { e.stopPropagation(); closeModal(); } });
    form.addEventListener('submit', onSubmit);
  }
  function openModal() {
    buildModal();
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    done.hidden = true;
    err.hidden = true;
    form.hidden = false;
    window.mcCartHelp.pauseDrawer('seniors');
    overlay.hidden = false;
    setTimeout(function () { input.focus(); }, 50);
  }
  function closeModal() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    window.mcCartHelp.resumeDrawer('seniors');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-scd-open]') : null;
    if (t) { e.preventDefault(); openModal(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) { e.stopPropagation(); closeModal(); } }, true);
  function onSubmit(e) {
    e.preventDefault();
    var card = (input.value || '').replace(/[\s-]/g, '');
    if (!/^[A-Za-z0-9]{6,14}$/.test(card)) { err.hidden = false; return; }
    err.hidden = true;
    btn.disabled = true;
    btn.textContent = 'Applying...';
    fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var eligibleSum = 0, kit = false, base = false;
        cart.items.forEach(function (it) {
          if (HANDLES.indexOf(it.handle) > -1) {
            eligibleSum += it.original_line_price;
            if (/sleep-kit/.test(it.handle)) kit = true; else base = true;
          }
        });
        var saving = Math.round(eligibleSum * 0.10);
        var payload = { attributes: { 'Seniors Card Number': card } };
        // The card is already on the cart (the shopper pressed Change): only the number changes.
        var already = (cart.discount_codes || []).some(function (d) { return d && d.applicable && String(d.code).toUpperCase() === CODE; });
        var keepExisting = !already && eligibleSum > 0 && cart.total_discount > 0 && cart.total_discount >= saving;
        if (!keepExisting && !already) payload.discount = CODE;
        // update.js alone applies the code on this theme; no second request to the /discount/ route (a cart emptied
        // once right after the card was applied when that route was also called, R4).
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (!r.ok) throw new Error('cart update failed');
          return r.json();
        }).then(function () {
          return { keepExisting: keepExisting, already: already, saving: saving, existing: cart.total_discount, eligibleSum: eligibleSum, kit: kit, base: base };
        });
      })
      .then(function (res) {
        form.hidden = true;
        if (res.already) {
          done.textContent = 'Card number updated. Your Seniors Card discount stays on the order.';
        } else if (res.keepExisting) {
          done.textContent = 'The discounts already in your cart save you more (' + money(res.existing) + ' off), so we kept them. Your Seniors Card number is saved with the order.';
        } else if (res.eligibleSum > 0) {
          done.textContent = 'Discount applied. ' + money(res.saving) + ' comes off your ' + (res.kit && res.base ? 'adjustable base and Sleep Kit' : res.kit ? 'Sleep Kit' : 'adjustable base') + ', and your cart now shows it.';
        } else {
          done.textContent = 'Card number saved. Add an adjustable base or Sleep Kit to your cart and 10 percent comes off it.';
        }
        done.hidden = false;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        closeTimer = setTimeout(closeModal, 4000);
      })
      .catch(function () {
        err.textContent = 'Something went wrong applying the discount. Please try again, or enter your card number in the order notes.';
        err.hidden = false;
      })
      .then(function () {
        btn.disabled = false;
        btn.textContent = 'Apply discount';
      });
  }
  // The base product page banner moves up beside the buy buttons.
  (function () {
    var banner = document.getElementById('scd-pdp-banner');
    if (!banner) return;
    var anchor = document.querySelector('.product-info .buy-buttons') || document.querySelector('form.buy-buttons') || document.querySelector('.buy-buttons');
    if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(banner, anchor); banner.hidden = false; }
  })();

  /* ---------- 3. emailed invoice ---------- */
  function ensureQuote() {
    if (window.mcBundleQuote) return window.mcBundleQuote;
    var tpl = document.getElementById('mc-cart-quote-tpl');
    if (!tpl || !tpl.content) return null;
    var holder = document.createElement('div');
    holder.id = 'mc-cart-quote';
    holder.appendChild(document.importNode(tpl.content, true));
    document.body.appendChild(holder);
    if (!window.mcBundleQuote) {
      // a browser that did not run the imported script gets a fresh copy of it, which always runs
      Array.prototype.forEach.call(holder.querySelectorAll('script'), function (old) {
        var s = document.createElement('script');
        s.text = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
    }
    return window.mcBundleQuote || null;
  }
  function openQuote(a) {
    var q = ensureQuote();
    if (!q) return false;
    var root = q.__root;
    var dlg = root && root.querySelector('[data-mcbq-dialog]');
    if (!dlg) return false;
    var src = root.querySelector('input[name="contact[Source]"]');
    var before = src ? src.value : null;
    // The form is worded for a bundle combination; opened from the cart it asks for the order instead, and the
    // page's own wording comes back when it closes.
    var words = [
      [root.querySelector('.mcbq-heading'), 'Send us your order'],
      [root.querySelector('.mcbq-sub'), 'Check the order below and we will reply by email with an invoice you can pay online.'],
      [root.querySelector('label[for="mcbq-combination"]'), 'Your order'],
      [root.querySelector('.mcbq-submit'), 'Send my order']
    ].filter(function (w) { return w[0]; }).map(function (w) { var old = w[0].textContent; w[0].textContent = w[1]; return [w[0], old]; });
    window.mcCartHelp.pauseDrawer('quote');
    q.open({ source: a.getAttribute('data-mc-quote-source') || 'Cart', summary: a.getAttribute('data-mc-quote-summary') || '' });
    var mo = new MutationObserver(function () {
      if (dlg.classList.contains('mcbq-is-open')) return;
      mo.disconnect();
      if (src && before !== null) src.value = before;
      words.forEach(function (w) { w[0].textContent = w[1]; });
      window.mcCartHelp.resumeDrawer('quote');
    });
    mo.observe(dlg, { attributes: true, attributeFilter: ['class'] });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-mc-help-quote]') : null;
    if (!a) return;
    e.preventDefault();
    if (openQuote(a)) return;
    // No quote form on this page: the cart page has one and opens it with the cart typed in.
    window.location.href = ROOT + 'cart#mc-send-order';
  });
  if (location.hash === '#mc-bundle-quote-form' && !window.mcBundleQuote) ensureQuote();
  if (location.hash === '#mc-send-order') {
    var link = document.querySelector('.mc-help--cart [data-mc-help-quote]');
    if (link) openQuote(link);
  }

  /* ---------- 4. delivery lines ---------- */
  var zLoading = null;
  function zones() {
    if (window.MC_ZONES) return Promise.resolve(window.MC_ZONES);
    if (!ZONES_URL) return Promise.resolve(null);
    if (!zLoading) {
      zLoading = new Promise(function (resolve) {
        var s = document.createElement('script');
        s.src = ZONES_URL; s.async = true;
        s.onload = function () { resolve(window.MC_ZONES || null); };
        s.onerror = function () { zLoading = null; resolve(null); };
        document.head.appendChild(s);
      });
    }
    return zLoading;
  }
  function postcode() { try { return (window.localStorage.getItem('mc_postcode') || '').trim(); } catch (e) { return ''; } }
  function isFree(zone) { return !!(zone && (zone[1] === 'free' || zone[1] === 'free-nextday')); }
  // "Delivery" in the totals: Free, Priced at checkout, or the checker link until a postcode is checked
  window.mcDeliveryFill = function (root) {
    root = root || document;
    if (!root.querySelector('[data-mc-deliv-val]')) return;
    var pc = postcode();
    if (!/^\d{4}$/.test(pc)) return;
    zones().then(function (z) {
      if (!z) return;
      var text = isFree(z[pc]) ? 'Free' : 'Priced at checkout';
      Array.prototype.forEach.call(root.querySelectorAll('[data-mc-deliv-val]'), function (el) {
        if (el.getAttribute('data-v') !== text) { el.textContent = text; el.setAttribute('data-v', text); }
      });
    });
  };
  // the drawer's top line
  function drawerDelivery() {
    var d = drawerEl();
    if (!d || !d.hasAttribute('open')) return;
    window.mcDeliveryFill(d);
    var code = postcode();
    if (!/^\d{4}$/.test(code) || !d.querySelector('[data-mc-cd-delivery]')) return;
    zones().then(function (z) {
      if (!z) return;
      var zone = z[code];
      var where = (zone && zone[0] ? zone[0] + ' ' : '') + code;
      var text = isFree(zone) ? 'Free delivery to ' + where : 'Delivery to ' + where + ' is priced at checkout before you pay';
      Array.prototype.forEach.call(d.querySelectorAll('[data-mc-cd-delivery]'), function (el) { if (el.textContent !== text) el.textContent = text; });
    });
  }
  document.addEventListener('mc:postcode', function () {
    drawerDelivery();
    var totals = document.querySelector('.cart-form__totals');
    if (totals) window.mcDeliveryFill(totals);
  });
  window.addEventListener('storage', function (e) { if (e.key === 'mc_postcode') drawerDelivery(); });
  (function () { var totals = document.querySelector('.cart-form__totals'); if (totals) window.mcDeliveryFill(totals); })();
  // "Check your postcode" goes to the checker on the cart page and puts the cursor in it.
  function toChecker() {
    var box = document.querySelector('[data-mc-delivery]');
    if (!box) return false;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var field = box.querySelector('[data-mc-postcode]');
    if (field) setTimeout(function () { try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); } }, 400);
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-mc-check-postcode]') : null;
    if (!a || a.closest('#cart-drawer')) return;
    if (toChecker()) e.preventDefault();
  });
  if (location.hash === '#mc-check-delivery') {
    var tries = 0;
    (function wait() { if (!toChecker() && tries++ < 20) setTimeout(wait, 250); })();
  }

  /* ---------- 5. cart drawer: chat, delivery refresh, Back ---------- */
  (function () {
    var drawer = drawerEl();
    if (!drawer) return;
    var timer = null;
    function soon() { clearTimeout(timer); timer = setTimeout(drawerDelivery, 30); }
    if (window.MutationObserver) new MutationObserver(soon).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('dialog:after-show', function (e) { if (e.target === drawer) drawerDelivery(); });

    // Back closes the drawer: opening it adds one history entry, Back pops it and the drawer closes. Closing it any
    // other way takes the entry off again; leaving from inside it (checkout, a link) takes it off first. With a popup
    // open over the drawer, Back closes the popup first.
    var canHistory = !!(window.history && history.pushState);
    var pushed = false, ignorePop = false, after = null, safety = null;
    function isOpen() { return drawer.hasAttribute('open'); }
    function finishUnwind() { ignorePop = false; clearTimeout(safety); var f = after; after = null; if (f) f(); }
    function unwind(then) {
      if (!pushed) { if (then) then(); return; }
      pushed = false; ignorePop = true; after = then || null;
      history.back();
      safety = setTimeout(function () { if (ignorePop) finishUnwind(); }, 700);
    }
    function popupOpen() {
      if (overlay && !overlay.hidden) return closeModal;
      var q = document.querySelector('[data-mcbq-dialog].mcbq-is-open');
      if (q && window.mcBundleQuote) return function () { window.mcBundleQuote.close(); };
      return null;
    }
    document.addEventListener('toggle', function (e) {
      if (e.target !== drawer) return;
      document.documentElement.classList.toggle('mc-cart-open', isOpen());
      if (!canHistory) return;
      if (isOpen()) {
        if (!pushed && !ignorePop) { history.pushState({ mcCart: 1 }, ''); pushed = true; }
      } else if (pushed) {
        unwind(null);
      }
    });
    if (!canHistory) return;
    window.addEventListener('popstate', function () {
      if (ignorePop) { finishUnwind(); return; }
      if (!pushed || !isOpen()) return;
      var closePopup = popupOpen();
      if (closePopup) { closePopup(); history.pushState({ mcCart: 1 }, ''); return; }
      pushed = false;
      drawer.hide();
    });
    drawer.addEventListener('submit', function (e) {
      if (!pushed || e.defaultPrevented) return;
      var f = e.target, submitter = e.submitter;
      e.preventDefault();
      unwind(function () {
        if (f.requestSubmit && submitter) { f.requestSubmit(submitter); return; }
        if (submitter && submitter.name) { var h = document.createElement('input'); h.type = 'hidden'; h.name = submitter.name; h.value = submitter.value || ''; f.appendChild(h); }
        f.submit();
      });
    });
    window.addEventListener('click', function (e) {
      if (!pushed || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || !drawer.contains(a) || (a.target && a.target !== '_self')) return;
      var raw = a.getAttribute('href') || '';
      if (/^(mailto:|tel:|#|javascript:)/i.test(raw)) return;
      e.preventDefault();
      var href = a.href;
      unwind(function () { window.location.href = href; });
    });
  })();

  /* ---------- 6. menu cart bag ---------- */
  (function () {
    Array.prototype.forEach.call(document.querySelectorAll('.mcnav-bag'), function (b) {
      var p = b.parentElement;
      if (p && p.querySelector('a.tcart')) b.parentNode.removeChild(b);
    });
    if (!document.querySelector('.mcnav-bag')) return;
    function setBags(n) {
      n = parseInt(n, 10);
      if (isNaN(n)) return;
      Array.prototype.forEach.call(document.querySelectorAll('.mcnav-bag'), function (b) {
        b.setAttribute('data-count', String(n));
        b.setAttribute('aria-label', 'Your cart, ' + n + (n === 1 ? ' item' : ' items'));
        var s = b.querySelector('.mcnav-bag-n'); if (s) s.textContent = n;
      });
    }
    // the menu's own script refreshes the "Your cart" pill from /cart.js on load; the bag follows it
    var pill = document.getElementById('mcnav-count');
    if (pill && window.MutationObserver) {
      setBags(pill.textContent);
      new MutationObserver(function () { setBags(pill.textContent); }).observe(pill, { childList: true, characterData: true, subtree: true });
    }
    var t = null;
    function refresh() {
      fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.item_count === 'number') { setBags(c.item_count); if (pill) pill.textContent = c.item_count; } })
        .catch(function () {});
    }
    function soon() { clearTimeout(t); t = setTimeout(refresh, 400); }
    ['cart:refresh', 'mc:card-added', 'mc:codes-synced'].forEach(function (ev) { document.addEventListener(ev, soon); });
    document.documentElement.addEventListener('cart:change', function (e) { var c = e.detail && e.detail.cart; if (c && typeof c.item_count === 'number') setBags(c.item_count); else soon(); });
  })();
})();
